import React, { Component, useContext, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Label, FormGroup, Col, Input } from 'reactstrap';
import { data_change_status, formatDate, funLogout } from "./globalFunction/response_action";
import './TotalCss.css'
import './FetchData.css';
import { api_url } from './globalFunction/global_string';
import DataTable from 'react-data-table-component'; // 引入 DataTable 組件
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

import { faEllipsisV, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { SelectNet } from "./BasicComponents/SelectNet";
import { SelectName } from "./BasicComponents/SelectName";
import { SelectUnitproxyApply } from "./BasicComponents/SelectUnitproxyApply";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactSelectUnitproxyApply } from "./BasicComponents/reactSelectUnitproxyApply";

function mapOpcallityToText(opcallity) {
  const level = {
    3: '高',
    2: '中',
    1: '普'
  };
  return level[opcallity] || '未知';
}
export class FetchDataResearch extends Component {
  static displayName = FetchDataResearch.name;
  constructor(props) {
    super(props);
    this.state = {
      showPasswordModal: false, //打開寄送密碼的modal
      fetchedData: props.fetchedData,
      apiUrl: props.fetchedData.apiUrl,
      current_user_type: props.fetchedData.current_user_type,
      local_net_id: props.fetchedData.local_net_id,
      local_unit_id: props.fetchedData.local_unit_id,
      url_addr: props.fetchedData.url_addr,
      selectedRisk: props.fetchedData.selectedRisk,
      betaversion: props.fetchedData.betaversion,
      startDate: props.fetchedData.startDate,
      endDate: props.fetchedData.endDate,
      forecasts: [],
      originalForecasts: [],
      tableLoading: true,
      fileLoading: false,
      sortColumn: null,
      historyData: [], // 存儲歷史數據
      allForecasts: [],
      expandedRows: {},
      showHistoryModal: false,
      urlMap: new Map(),
      columnSort: { url_addr: 'asc', unit_name: 'asc', important: 'asc', building_time: 'asc', lastest_sacn_time: 'asc', lastest_sacn_state: 'asc', danger_high: 'asc', danger_medium: 'asc', danger_low: 'asc', danger_message: 'asc' },
      filterText: '',
    };
    // 綁定函數到類的實例上
    this.handleShowPasswordModal = this.handleShowPasswordModal.bind(this);
    this.handleClosePasswordModal = this.handleClosePasswordModal.bind(this);

  }




  componentDidMount() {
    const selectedUnit = this.state.fetchedData.selectedUnit;
    const local_unit_name = this.state.fetchedData.local_unit_name;
    const selectedRisk = this.state.fetchedData.selectedRisk;
    const betaversion = this.state.fetchedData.betaversion;
    this.setState({ selectedUnit, local_unit_name, selectedRisk, betaversion }, () => {
      this.populateWeatherData();
    });
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.fetchedData !== prevProps.fetchedData ||
      this.props.selectnet !== prevProps.selectnet ||
      this.props.selectedUnitproxy !== prevProps.selectedUnitproxy ||
      this.props.local_net_name !== prevProps.local_net_name ||
      this.props.betaversion !== prevProps.betaversion
    ) {
      this.populateWeatherData();
    }
  }

  //下載報告
  DownLoadPaper = async (scan_id) => {
    this.setState({ fileLoading: true });
    const apiUrl = api_url + "/api/SCHE/CheckAndDownloadReportAsync";
    const formData = new FormData();
    formData.append("scan_id", scan_id);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Authorization": localStorage.getItem('accessToken')
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      let arr_status = [String(data.statusCode), data.row, data.detail];
      const row = arr_status[1] !== null && arr_status[1] !== '' ? arr_status[1] : '';

      const regex = /\/Upload\/[^\/]+\.zip/;
      const match = row.match(regex);
      const converted = match ? match[0] : '';

      console.log(api_url + converted);

      const fileUrl = `${api_url}${converted}`;
      const fileResponse = await fetch(fileUrl);

      if (!fileResponse.ok) {
        throw new Error(`HTTP error! status: ${fileResponse.status}`);
      }

      const blob = await fileResponse.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const finalFileName = converted.replace('/Upload/', '');
      a.download = finalFileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error:', error);
    } finally {
      this.setState({ fileLoading: false });
    }
  }



  // 打開歷史紀錄
  showHistory(row) {
    const filteredRows = this.state.allForecasts.filter(
      forecast => forecast.url_addr === row.url_addr
    );

    // 確保使用數字型態進行排序
    const sortedRows = filteredRows.sort((a, b) => Number(b.historyNumber) - Number(a.historyNumber));

    // 將sortedRows存儲到sessionStorage中
    const sortedRowsJson = JSON.stringify(sortedRows);
    sessionStorage.setItem('CurrentHistoryData', sortedRowsJson);

    // 更新當前的狀態
    this.setState({ currentHistoryData: sortedRows, showHistoryModal: true });
  }

  toggleRow = (scanId) => {
    this.setState(prevState => ({
      expandedRows: {
        ...prevState.expandedRows,
        [scanId]: !prevState.expandedRows[scanId]
      }
    }));
  }




  //打開寄送密碼model
  handleShowPasswordModal = (rowGuid, scanname, net_name, unit_name) => {
    this.setState({ showPasswordModal: true, currentGuid: rowGuid, scanname: scanname, net_name: net_name, unit_name: unit_name });
  };
  //關掉寄送密碼model
  handleClosePasswordModal = () => {
    this.setState({ showPasswordModal: false }, () => {
      // console.log("Modal closed, new state:", this.state.showPasswordModal);
    });
  };

  //寄送報告密碼
  handleSendReportPaswword = async () => {
    let apiUrl = api_url + "/api/async/SendReportPaswword";
    const formData = new FormData();
    const { selectnet, selectedUnitproxy, selecteduser, currentGuid, scanname, net_name, unit_name, userType } = this.state;
    if (userType === "S") {
      if (!selectnet || !selectedUnitproxy || !selecteduser) {
        Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
        return; // 提前終止函數
      }
    } else if (userType === "M") {
      if (!selectedUnitproxy || !selecteduser) {
        Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
        return; // 提前終止函數
      }
    } else if (userType === "N") {
      if (!selecteduser) {
        Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
        return; // 提前終止函數
      }
    }


    formData.append("send_user_id", localStorage.getItem('login_user_id'));
    formData.append("local_net_id", selectnet);
    formData.append("local_unit_id", selectedUnitproxy);
    formData.append("user_id", selecteduser)
    formData.append("currentGuid", currentGuid);
    formData.append("scanname", scanname);
    formData.append("net_name", net_name);
    formData.append("unit_name", unit_name);
    formData.append("type", "HCL");

    await fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        if (data.statusCode === 200) {
          Swal.fire("成功", "報告密碼寄送成功。", "success");
          this.handleClosePasswordModal(); // 關閉密碼模態框
        } else {
          Swal.fire("錯誤", "寄送失敗，請重試。", "error");
        }
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }


  renderPasswordModal = () => {
    const userType = localStorage.getItem('login_user_type');
    const net_name = localStorage.getItem('login_user_net_name');
    let formContent;
    if (userType === 'S') {
      formContent = (
        <>
          <FormGroup row inline>
            <Label for="local_net_id" sm={2}>區網名稱</Label>
            <Col sm={10}>
              <SelectNet
                parentName={'superS'}
                id={'excel_net_name'}
                name={'excel_net_name'}
                requiredAPI={'/api/JRCC/GetLocalNetId'}
                handleNetSelectChange={this.handleNetSelectChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
            <Col sm={10}>
              <ReactSelectUnitproxyApply
                parentName={'superS'}
                id={'excel_unit_proxy_name'}
                name={'excel_unit_proxy_name'}
                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                SelectUnitproxyApply={this.SelectUnitproxyApply}
                selectnet={this.state.selectnet}
                local_net_name={this.state.local_net_name}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="local_user_id" sm={2}>人員資料</Label>
            <Col sm={10}>
              <SelectName
                parentName={'superS'}
                id={'excel_user_name'}
                name={'excel_user_name'}
                requiredAPI={'/api/Async/GetUserdatalist'}
                handleUserSelectChange={this.handleUserSelectChange}
                selectedUnitproxy={this.state.selectedUnitproxy}
                local_unit_proxy_name={this.state.local_unit_proxy_name}
                selectnet={this.state.selectnet}
                local_net_name={this.state.local_net_name}
              />
            </Col>
          </FormGroup>
        </>
      );
    } else if (userType === 'M') {
      formContent = (
        <>
          <FormGroup row inline>
            <Label sm={2}>區網名稱</Label>
            <Col sm={10}>
              <span className="form-control-plaintext">{net_name}</span>
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
            <Col sm={10}>
              <ReactSelectUnitproxyApply
                parentName={'superM'}
                id={'excel_unit_proxy_name'}
                name={'excel_unit_proxy_name'}
                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                SelectUnitproxyApply={this.SelectUnitproxyApply}
                selectnet={this.state.fetchedData.local_net_id}
                local_net_name={net_name}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="local_user_id" sm={2}>人員資料</Label>
            <Col sm={10}>
              <SelectName
                parentName={'superM'}
                id={'excel_user_name'}
                name={'excel_user_name'}
                requiredAPI={'/api/Async/GetUserdatalist'}
                handleUserSelectChange={this.handleUserSelectChange}
                selectedUnitproxy={this.state.selectedUnitproxy}
                local_unit_proxy_name={this.state.local_unit_proxy_name}
                selectnet={this.state.fetchedData.local_net_id}
                local_net_name={net_name}
              />
            </Col>
          </FormGroup>
        </>
      );
    } else {
      formContent = (
        <FormGroup row inline>
          <Label for="local_user_id" sm={2}>人員資料</Label>
          <Col sm={10}>
            <SelectName
              parentName={'superN'}
              id={'excel_user_name'}
              name={'excel_user_name'}
              requiredAPI={'/api/Async/GetUserdatalist'}
              handleUserSelectChange={this.handleUserSelectChange}
            />
          </Col>
        </FormGroup>
      );
    }

    return (
      <Modal isOpen={this.state.showPasswordModal} toggle={this.handleClosePasswordModal} size="lg">
        <ModalHeader toggle={this.handleClosePasswordModal}>寄送密碼</ModalHeader>


        <ModalBody>
          <ModalBody>
            {formContent}
          </ModalBody>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={this.handleClosePasswordModal}>
            取消
          </Button>
          {' '}
          <Button color="primary" onClick={this.handleSendReportPaswword}>
            確認
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  // 處理網域選擇
  handleNetSelectChange = (data) => {
    const { value, selectedName } = data;
    this.setState({ selectnet: value, local_net_name: selectedName }, () => {
      console.log("Selected net updated:", this.state.selectnet, this.state.local_net_name);
    });
  };
  SelectUnitproxyApply = (data) => {
    const { value, selectedName } = data;
    this.setState({ selectedUnitproxy: value, local_unit_proxy_name: selectedName }, () => {
      console.log("Selected unit updated:", this.state.selectedUnitproxy, this.state.local_unit_proxy_name);
    });
  };
  // 處理人員選擇
  handleUserSelectChange = (data) => {
    const { value, selectedName } = data;
    this.setState({ selecteduser: value, local_user_name: selectedName }, () => {
      console.log("Selected net updated:", this.state.selecteduser, this.state.local_user_name);
    });
  };

  //修改追蹤報告資料
  handleModifyreport = (scan_id) => {
    window.location.href = `/FetchTrackingDetail/${scan_id}`;
  };

  //搜尋框
  handleFilterChange = (e) => {
    const originalForecasts = this.state.originalForecasts || this.state.forecasts;
    const filterText = e.target.value;

    let updatedForecasts;
    if (filterText) {
      updatedForecasts = originalForecasts.filter((item) => {
        const searchString = `${item.local_unit_name} ${item.url_name} ${item.url_addr} ${mapOpcallityToText(item.opcallity)} ${item.build_id} ${item.build_date}`.toLowerCase();
        return searchString.includes(filterText.toLowerCase());
      });
    } else {
      updatedForecasts = originalForecasts;
    }
    this.setState({ filterText, forecasts: updatedForecasts });
  };


  render() {
    const { totalSites, highRiskSites, mediumRiskSites, lowRiskSites, messageRiskSites, heavyRiskSites } = this.state;
    const RiskHeader = ({ title, color }) => {
      return (
        <div style={{
          display: 'inline-block',
          backgroundColor: color,
          padding: '10px',
          borderRadius: '0px',
          color: 'white',
          margin: '0px'
        }}>
          {title}
        </div>
      );
    };

    const StatusIndicator = ({ isTrackedreport, betaversion }) => {
      let color;
      const numericIsTrackedreport = +isTrackedreport;
      if (betaversion === "1" || betaversion === "2") {
        color = 'grey';
      } else if (betaversion === "3") {
        switch (numericIsTrackedreport) {
          case 2:
            color = 'green';
            break;
          case 1:
            color = 'red';
            break;
          default:
            color = 'grey';
            break;
        }
      }

      return (
        <div style={{
          width: '15px',
          height: '15px',
          borderRadius: '50%',
          backgroundColor: color,
          display: 'inline-block',
        }} />
      );
    };


    const columns = [
      {
        name: '追蹤狀態',
        cell: row => (
          <StatusIndicator
            isTrackedreport={row.isTrackedreport}
            betaversion={row.betaversion}
          />
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        name: '流水號',
        cell: row => {
          const originalFormat = row.build_date;
          const newFormat = originalFormat.replace(/\//g, "").replace(/:/g, "").replace(/ /g, "");
          return (
            <div className="Research-wrap">
              {`${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`}
            </div>
          );
        },
        sortable: true,
      },
      {
        name: '單位',
        selector: row => row.local_unit_name,
        cell: row => <div className="Research-wrap">{row.local_unit_name}</div>,
        sortable: true,
      },
      {
        name: '網站名稱',
        cell: row => {
          const BuildingDateText = formatDate(row.build_date);
          let opcallityText;
          if (row.opcallity === '1') {
            opcallityText = '普';
          } else if (row.opcallity === '2') {
            opcallityText = '中';
          } else if (row.opcallity === '3') {
            opcallityText = '高';
          } else {
            opcallityText = '其他';
          }

          const urlAddr = row.url_addr === undefined
            ? row.sche0101_url_addr : row.url_addr;
          const urlName = row.url_name === undefined
            ? row.sche0101_url_name : row.url_name;

          return (
            <div>
              <a href={urlAddr}>{urlName}</a>
              <br />
              {BuildingDateText}
              <br />
              {opcallityText}
            </div>
          );
        },
      },

      {
        name: '狀態',
        selector: row => row.scan_status,
        cell: row => {
          if (row.scan_status === '2') return '掃描成功';
          if (row.scan_status === '1') return '掃描中';
          if (row.scan_status === '3') return `掃描失敗 ${row.note}`;
          if (row.scan_status === '0') return '排程中';
          return '未知';
        },
        sortable: true,
      },
      {
        name: '版本',
        selector: row => row.betaversion,
        cell: row => {
          if (row.betaversion === '3') return '正式版';
          if (row.betaversion === '2') return '測試版';
          if (row.betaversion === '1') return `開發版`;
          return '未知';
        },
        sortable: true,
      },
      {
        name: <RiskHeader title="重風險" color="purple" />,
        selector: row => row.heavy,
      },
      {
        name: <RiskHeader title="高風險" color="red" />,
        selector: row => row.high,
      },
      {
        name: <RiskHeader title="中風險" color="orange" />,
        selector: row => row.meddle,
      },
      {
        name: <RiskHeader title="低風險" color="blue" />,
        selector: row => row.low,
      },
      {
        name: <RiskHeader title="訊息" color="green" />,
        selector: row => row.message,
      },
      {
        name: '建立人員',
        selector: row => row.build_id,
        sortable: false,
      },
      {
        name: '操作',
        cell: row => {
          const historyNumber = this.state.urlMap.get(row.url_addr);
          const userType = this.state.fetchedData.current_user_type;
          // 判斷單位追蹤是否為 1，且用戶是否為區網用戶，超級用戶不受此條件限制
          const isUnitTracked = row.isUnitTracked === '1';
          const isExpanded = this.state.expandedRows[row.scan_id] || false;
          const isTrackedreport = row.isTrackedreport === '1';
          const rowGuid = row.id;
          const originalFormat = row.build_date;
          const newFormat = originalFormat.replace(/[/: ]/g, "");
          const scanname = `${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`;
          const net_name = row.local_net_name;
          const unit_name = row.local_unit_name;

          return (
            <div>
              {/* 下載報告按鈕 */}
              {row.scan_status === "2" && row.downland_url && (
                <Button type="button" className='btn btn-primary mx-1' onClick={() => this.DownLoadPaper(row.scan_id)}>下載報告</Button>
              )}

              {/* 展開/收起按鈕 */}
              <Button type="button" className='btn btn-light mx-1' onClick={() => this.toggleRow(row.scan_id)}>
                <FontAwesomeIcon icon={isExpanded ? faEyeSlash : faEllipsisV} size="2x" />
              </Button>
              {/* 附加操作按鈕 */}
              {isExpanded && (
                <>
                  {/* 歷史紀錄按鈕 */}
                  {historyNumber >= 1 && (
                    <Link
                      onClick={() => this.showHistory(row)}
                      to={{
                        pathname: `/cia-scanner/Site-Scan-History-Data`,
                        state: { currentHistoryData: this.state.currentHistoryData }
                      }}
                      className='btn btn-secondary mx-1'>
                      歷史紀錄
                    </Link>
                  )}
                  {/* 寄送密碼 */}
                  {row.scan_status === "2" && row.downland_url && (
                    <Button
                      type="button"
                      className="btn btn-secondary mx-1"
                      onClick={() => this.handleShowPasswordModal(rowGuid, scanname, net_name, unit_name)}
                    >
                      寄送密碼
                    </Button>
                  )}
                </>
              )}
            </div>
          );
        },
        sortable: false,
      },

    ];


    if (this.state.fetchedData.current_user_type === 'S') {
      columns.splice(1, 0, {
        name: '區網',
        selector: row => row.local_net_name,
        cell: row => <div className="Research-wrap">{row.local_net_name}</div>,
        sortable: true,
      });
    }
    return (
      <div>
        <div>
          <Row>
            <Col className="riskSummaryBox"><strong>總共網站數量: {totalSites}</strong></Col>
            <Col className="riskSummaryBox"><strong>重風險網站數量: {heavyRiskSites}</strong></Col>
            <Col className="riskSummaryBox"><strong>高風險網站數量: {highRiskSites}</strong></Col>
            <Col className="riskSummaryBox"><strong>中風險網站數量: {mediumRiskSites}</strong></Col>
            <Col className="riskSummaryBox"><strong>低風險網站數量: {lowRiskSites}</strong></Col>
            <Col className="riskSummaryBox"><strong>訊息風險網站數量: {messageRiskSites}</strong></Col>
          </Row>
        </div>

        <div
          style={{
            position: "relative",
            width: "120%",        // 讓 DataTable 超出畫面
            borderRadius: "inherit",
            overflowX: "hidden",  // 隱藏超出的部分
            overflowY: "hidden",
            minHeight: "0",
            right: "100px",       // 讓 DataTable 右移 100px
          }}
        >
          <DataTable
            columns={columns}
            data={this.state.forecasts}
            pagination
            paginationPerPage={20}
            paginationRowsPerPageOptions={[20, 50, this.state.forecasts.length]}
            noDataComponent="沒有找到對應資料"
            tableStyle={{ minWidth: "50rem" }}
            subHeader
            subHeaderComponent={
              <div className="row justify-content-end">
                <div className="col-md-4 input-group">
                  <div className="input-group-prepend bg-info">
                    <span className="input-group-text bg-info" style={{ borderTopLeftRadius: "0.7rem", borderBottomLeftRadius: "0.7rem" }}>
                      <FontAwesomeIcon icon={faSearch} color="white" />
                    </span>
                  </div>
                  <Input
                    type="text"
                    placeholder="篩選-請輸入文字..."
                    value={this.state.filterText}
                    onChange={this.handleFilterChange}
                    className="form-control"
                  />
                </div>
              </div>
            }
            customStyles={{
              headRow: {
                style: { background: "transparent" },
              },
              headCells: {
                style: { fontSize: "14px", fontWeight: "bold" },
              },
            }}
            customFilterText={this.state.filterText}
            onFilter={(e) => this.customFilter(e)}
          />
        </div>

        {this.renderPasswordModal()}

        {this.state.fileLoading && (
          <div className="modal-backdrop d-flex justify-content-center align-items-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">載入中...</span>
            </div>
          </div>
        )}

        <div style={{ backgroundColor: "lightblue", color: "black", padding: "10px", marginTop: "20px" }}>
          <h4>注意事項</h4>
          <p>掃描失敗的錯誤訊息:</p>
          <ol>
            <li>
              <strong>掃描失敗 已暫停 (錯誤不明：SDK Server Down Error)</strong>
              <p>原因：執行弱掃的掃描過程中導致網頁伺服器掛掉。</p>
              <p>解決方式：請確認網頁伺服器已經可以正確運行後，再次執行掃描。如果仍出現該問題，請聯繫系統維護人員。</p>
            </li>
            <li>
              <strong>掃描失敗 已暫停 (記憶體不足錯誤。)</strong>
              <p>原因：此為弱掃平台掃描主機出現錯誤。</p>
              <p>解決方式：請聯繫系統維護人員。</p>
            </li>
            <li>
              <strong>掃描失敗 已暫停 (錯誤不明：SDK Error. Scan failed to start. Either starting URL is not accessible or other network issues.)</strong>
              <p>原因：這是因為掃描主機無法與被掃瞄的主機相連。</p>
              <p>解決方式：</p>
              <ul>
                <li>被掃描主機網址是錯誤的，請確認主機網址可以被連線。</li>
                <li>被掃描主機未開機。</li>
                <li>未將140.113.27.234在防火牆上設定白名單。</li>
              </ul>
            </li>
            <div style={{ margin: "1em 0" }}></div>
            <li>
              <strong>掃描失敗 已暫停 (錯誤不明：無效的 URI: 無法決定 URI 的格式。)</strong>
              <p>原因：輸入的資訊不是一個網址。</p>
              <p>解決方式：請確認輸入為 http://xxx.xxx/ 或 https://xxx.xxx/。</p>
            </li>
          </ol>
        </div>
      </div>
    );

  }


  async populateWeatherData() {
    const formData = new FormData();
    const { current_user_type, local_net_id, local_unit_id, url_addr, startDate, endDate } = this.state;

    formData.append("current_user_type", current_user_type);
    formData.append("starttime", startDate);
    formData.append("endtime", endDate);
    switch (current_user_type) {
      case "S":
        formData.append("local_net_id", this.props.fetchedData.selectnet || "");
        formData.append("local_unit_id", this.props.fetchedData.selectedUnitproxy || "");
        formData.append("local_unit_name", this.props.fetchedData.local_unit_proxy_name);
        break;
      case "M":
        formData.append("local_net_id", local_net_id);
        formData.append("local_unit_id", this.props.fetchedData.selectedUnitproxy || "");
        break;
      case "N":
        formData.append("local_unit_id", local_unit_id);
        formData.append("local_net_id", local_net_id);
        break;
      default:
        break;
    }
    formData.append("url_addr", url_addr);
    formData.append("selectedRisk", this.props.fetchedData.selectedRisk);
    formData.append("betaversion", this.props.fetchedData.betaversion);

    try {
      const response = await fetch(this.state.apiUrl, {
        method: "POST",
        headers: { "Authorization": localStorage.getItem('accessToken') },
        body: formData
      });
      const data = await response.json();
      const rows = Array.isArray(data.row) ? data.row : [data.row];

      const selectedRisk = this.props.fetchedData.selectedRisk;
      const betaversion = this.props.fetchedData.betaversion;

      const filteredRows = rows.filter(row => {
        let matchesRisk = false;
        const heavy = parseInt(row.heavy, 10);
        const high = parseInt(row.high, 10);
        const middle = parseInt(row.meddle, 10);
        const low = parseInt(row.low, 10);
        const message = parseInt(row.message, 10);

        switch (selectedRisk) {
          case "Heavy":
            matchesRisk = heavy > 0;
            break;
          case "High":
            matchesRisk = heavy === 0 && high > 0;
            break;
          case "Medium":
            matchesRisk = heavy === 0 && high === 0 && middle > 0;
            break;
          case "Low":
            matchesRisk = heavy === 0 && high === 0 && middle === 0 && low > 0;
            break;
          case "Message":
            matchesRisk = heavy === 0 && high === 0 && middle === 0 && low === 0 && message === 0;
            break;
          default:
            matchesRisk = true; // 默认包含此行
        }


        if (betaversion !== "0") {
          // 也将 betaversion 字段从字符串转换为数字进行比较
          return matchesRisk && parseInt(row.betaversion, 10) === parseInt(betaversion, 10);
        } else {
          return matchesRisk;
        }
      });


      const latestRowsMap = new Map(); // 只包含 historyNumber === "1" 的资料
      const urlCountMap = new Map(); // 包含所有的 url_addr

      filteredRows.forEach(row => {
        const urlToCount = row.url_addr === undefined ? row.sche0101_url_addr : row.url_addr;
        const count = urlCountMap.get(urlToCount) || 0;
        urlCountMap.set(urlToCount, count + 1);
      });

      const latestFilteredRows = filteredRows.filter(row => row.historyNumber === "1");
      latestFilteredRows.forEach(row => {
        latestRowsMap.set(row.url_addr, row);
      });

      const latestRows = Array.from(latestRowsMap.values());
      if (latestRows && Array.isArray(latestRows)) {
        latestRows.sort((a, b) => {
          return new Date(b.build_date).toISOString().localeCompare(new Date(a.build_date).toISOString());
        });
      }

      let totalSites = latestRows.length;
      let heavyRiskSites = latestRows.filter(row => row.heavy > "0").length;
      let highRiskSites = latestRows.filter(row => row.heavy === "0" && row.high > "0").length;
      let mediumRiskSites = latestRows.filter(row => row.heavy === "0" && row.high === "0" && row.meddle > "0").length;
      let lowRiskSites = latestRows.filter(row => row.heavy === "0" && row.high === "0" && row.meddle === "0" && row.low > "0").length;
      let messageRiskSites = latestRows.filter(row => row.heavy === "0" && row.high === "0" && row.meddle === "0" && row.low === "0" && row.message > "0").length;

      this.setState({
        allForecasts: filteredRows, // 所有资料
        forecasts: latestRows, // 只有 historyNumber === "1" 的资料
        totalSites,
        heavyRiskSites,
        highRiskSites,
        mediumRiskSites,
        lowRiskSites,
        messageRiskSites,
        tableLoading: false,
        urlMap: urlCountMap, // 包含所有 url_addr 的计数
        originalForecasts: filteredRows,
      });
    } catch (error) {
      console.log('Error fetching JSON:', error);
    }
  }
} 